import React, { FC, useMemo } from 'react'
import { InputSelect, Media, TextBox } from '@revolut/ui-kit'
import { formatMoney, FormatMoneyRequest } from 'helpers/common'
import { Pocket } from 'types/common'
import { currencies } from 'constants/currencies'

type AccountSelectProps = {
  accounts: Pocket[]
  onChange: (accountId: string) => void
  value: string | null
}

export const AccountSelect: FC<AccountSelectProps> = ({ accounts, onChange, value }) => {
  const options = useMemo(
    () =>
      accounts.map<{ label: string; value: string } & FormatMoneyRequest>(
        ({ id, balance, currency }) => ({
          label: `${currency} · ${currencies[currency].currency}`,
          currency,
          amount: balance,
          value: id,
        }),
      ),
    [accounts],
  )

  return (
    <InputSelect
      input={{ variant: 'filled', placeholder: 'Select account' }}
      renderLabel={({ selectedItem }) => (
        <TextBox color='grey-50' mx={1}>
          {selectedItem
            ? formatMoney({
                currency: selectedItem.currency,
                amount: selectedItem.amount,
                showDecimal: selectedItem.showDecimal,
              })
            : ''}
        </TextBox>
      )}
      renderOption={(item, select) => (
        <InputSelect.Option key={item.value} {...select.getOptionProps(item)}>
          <Media>
            <Media.Content>{item.label}</Media.Content>
            <Media.Side ml={1} color='grey-50'>
              {formatMoney({
                currency: item.currency,
                amount: item.amount,
                showDecimal: item.showDecimal,
              })}
            </Media.Side>
          </Media>
        </InputSelect.Option>
      )}
      onChange={onChange}
      value={value}
      options={options}
    />
  )
}
